import { merge } from "lodash";
import { fetcher } from "../utils/fetcher";
import * as vimeo from "../utils/vimeo";

class VideoBanner {
  constructor(element, options){   
    this.settings = merge( {}, VideoBanner.DEFAULTS, options );
    this.player = element;
    this.isInitialised = false;
    this.isLoaded = false;

    this.renderPlayer = this.renderPlayer.bind(this);

    this.init();
  }

  init(){
    if(!this.settings.lazy) {
      this.initVideo();
    }

    const intersectionCallback = (entries, observer) => {
      entries.forEach(entry => {
        const isVideoReady = this.isInitialised && this.isLoaded;
        
        if (entry.isIntersecting) {
          if( this.settings.lazy && !this.isInitialised ) {
            this.initVideo();
          } else if(isVideoReady){
            this.player.play();
          }
        } else if(isVideoReady) {
          this.player.pause();
        }
      });
    }
    
    const observer = new IntersectionObserver(intersectionCallback, {
      root: null,
      rootMargin: '0px 0px 500px 0px',
      threshold: 0
    });

    observer.observe(this.player);    
  }

  initVideo(){
    const { videoUrlPortrait } = this.settings;

    this.isInitialised = true;
    this.mq = window.matchMedia(`(orientation: portrait)`);    
    this.renderPlayer();

    if( videoUrlPortrait ) {
      this.mq.addEventListener('change', this.renderPlayer );
    }
  }

  async renderPlayer(){
    const { videoUrl: videoUrlDesktop, videoUrlPortrait } = this.settings;
    const videoUrl = this.mq.matches && videoUrlPortrait ? videoUrlPortrait : videoUrlDesktop;
    this.player.src = videoUrl;
    this.isLoaded = true;
  }
}

VideoBanner.DEFAULTS = {
  videoUrl: null,
  videoUrlPortrait: null,
  lazy: true
};

const banners = document.querySelectorAll('.js-VideoBanner');

banners.forEach(banner => {
  new VideoBanner(banner, {
    ...banner.dataset,
    lazy: banner.dataset.lazy !== "false"
  })
})